var app = angular.module("leonardo");

var TaskRecurrenceDialog = function($scope, $rootScope, TemplateService, AccountUserService, FormErrorsService,
                                    NotificationService, PortfolioService, PropertyService) {

  $scope.task = $scope.ngDialogData.task;
  $scope.template = $scope.ngDialogData.template;
  $scope.portfolio = '';
  if ($scope.template && $scope.template.portfolio) {
    $scope.portfolio = $scope.template.portfolio;
  }
  else {
    $scope.portfolio = $scope.ngDialogData.portfolio ? $scope.ngDialogData.portfolio : '';
  }

  $scope.property = '';
  if ($scope.template && $scope.template.property) {
    $scope.property = $scope.template.property;
  }
  else {
    $scope.property = $scope.ngDialogData.property ? $scope.ngDialogData.property : '';
  }
  $scope.recurrenceOptions = angular.copy(TemplateService.RECURRENCE_OPTIONS);
  $scope.templateService = TemplateService;
  $scope.portfolios = [];
  $scope.properties = [];

  $scope.getPortfolios = function() {
    if (angular.isArray($scope.portfolio)) {
      return $scope.portfolio;
    }
    else {
      if (!isNull($scope.portfolio)) {
        return angular.isString($scope.portfolio) ? $scope.portfolio.split(',') : [$scope.portfolio];
      }
      else {
        return [];
      }
    }
  };

  $scope.getProperties = function() {
    if (angular.isArray($scope.property)) {
      return $scope.property;
    }
    else {
      if (!isNull($scope.property)) {
        return angular.isString($scope.property) ? $scope.property.split(',') : [$scope.property];
      }
      else {
        return [];
      }
    }
  };

  $scope.portfolios = !isEmpty($scope.getPortfolios()) ?
    PortfolioService.getlist({disable_pagination:true, essential:true, id:$scope.getPortfolios()}) : null;
  $scope.properties = !isEmpty($scope.getProperties()) ?
    PropertyService.getlist({disable_pagination:true, essential:true, id:$scope.getProperties()}): null;

  if ($scope.task) {
    $scope.recurrence = {
      type: $scope.task.recurrence_type.toString(),
      recurrence: angular.copy($scope.task.recurrence),
    };
  }
  else if ($scope.template) {
    $scope.recurrence = {
      type: $scope.template.recurrence_type.toString(),
      recurrence: angular.copy($scope.template.recurrence),
    };
  }

  $scope.submit = function() {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    var portfolios = !isNull($scope.properties_data) && !isEmpty($scope.properties_data.portfolios) ?
      $scope.properties_data.portfolios : [];
    var properties = !isNull($scope.properties_data) && !isEmpty($scope.properties_data.properties) ?
      $scope.properties_data.properties : [];
    if ($scope.template) {
      $scope.template.setRecurrence({
        recurrence: $scope.recurrence.recurrence,
        recurrence_type: $scope.recurrence.type,
        portfolios: portfolios,
        properties: properties
      }).then(function(data) {
        $rootScope.$broadcast('task-recurrence-dialog:success', data);
        $scope.confirm();
      });
    }
    else if ($scope.task) {
      $scope.task.setRecurrence({
        recurrence: $scope.recurrence.recurrence,
        recurrence_type: $scope.recurrence.type,
        portfolios: portfolios,
        properties: properties
      }).then(function(data) {
        $rootScope.$broadcast('task-recurrence-dialog:success', data);
        $scope.closeThisDialog();
      });
    }
  };
};

app.controller('TaskRecurrenceDialog', ['$scope', '$rootScope', 'TemplateService', 'AccountUserService',
  'FormErrorsService', 'NotificationService', 'PortfolioService', 'PropertyService', TaskRecurrenceDialog]);
